import {Component, Inject, Input, OnChanges, SimpleChanges, ViewEncapsulation,} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {MessagesService} from '../services/messages.service';
import postscribe from 'postscribe';
import { createFirestoreId } from '../../common/firestore-utils';
import { Firestore } from '@angular/fire/firestore';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: "view-html",
    template: `
    <div class="ql-container" class="ql-snow ql-view-html">
      <div class="ql-editor" [innerHTML]="innerHTML"></div>
    </div>
  `,
    standalone: true,
})
export class ViewHtmlComponent implements OnChanges {
  @Input() content = "";
  innerHTML: SafeHtml = "";

  constructor(
    @Inject(DomSanitizer) private sanitizer: DomSanitizer,
    private messages: MessagesService,
    private firestore: Firestore
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.content) {
      const content = changes.content.currentValue;

      this.innerHTML = this.sanitizer.bypassSecurityTrustHtml(
        this.removeCloseButtonfromHtml(content)
      );

      // applying the embedded code to the DOM
      // this timeout is currently needed for the HTML to be applied to the DOM, no other way
      setTimeout(() => {
        const embeds = document.querySelectorAll("[data-embedded-html]");

        embeds.forEach((embed: HTMLElement) => {

          const embeddedHtml = embed.dataset.embeddedHtml;
          embed.style.all = "initial";
          embed.innerHTML = "";
          const sandbox = document.createElement("div");
          sandbox.style.all = "initial";
          const embedId = createFirestoreId(this.firestore)

          sandbox.id = embedId;

          embed.appendChild(sandbox);

          postscribe(`#${embedId}`, embeddedHtml, {
            releaseAsync:true
          });

        });
      });
    }
  }

  removeCloseButtonfromHtml(html: string) {
    // Create a temporary div element to hold the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Find the <button.closeElement> element inside the tempDiv
    const buttonElement = tempDiv.querySelectorAll("button.closeButton");

    // Remove the <button.closeButton> element if it exists
    if (buttonElement) {
      buttonElement.forEach((element) => {
        element.parentNode.removeChild(element);
      });
    }

    // Get the updated HTML string from the tempDiv
    return tempDiv.innerHTML.toString();
  }
}
